// SecuritySettings only. Shared table methods are in tableMixin.js.
export default {
    name: "SecuritySettings",
    methods: {
        clearForm() {
            this.isEditing = false;
            this.isSaving = false;
            this.submitted = false;
            this.formInputs = this.getDefaultFormInputs(); // every field, incl. MFA Email and Inactivity
            this.$clearValidationStates("#recordForm");
        },
    },
};